import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse/lib/mock-api/mock-api.service';

@Injectable({
  providedIn: 'root'
})
export class TestCorsMockApi {
  constructor(private _fuseMockApiService: FuseMockApiService) {
    this.registerHandlers();
  }

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // Test CORS Error - Simulates a network error with status 0
    this._fuseMockApiService
      .onGet('api/test/cors-error')
      .reply(() => {
        // Return error response with status 0 (CORS error)
        return [0, { error: 'CORS Error' }];
      });

    // Test Network Error - Simulates network timeout/failure
    this._fuseMockApiService
      .onGet('api/test/network-error')
      .reply(() => {
        // Return error response with status 0 (Network error)
        return [0, { error: 'Network Error' }];
      });

    // Test Success - For comparison
    this._fuseMockApiService
      .onGet('api/test/success')
      .reply(() => [200, { message: 'Success', data: 'Test data' }]);
  }
}

